import React, { useState } from 'react';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

export interface CopyButtonProps {
  text: string;
}

export const CopyButton = ({ text }: CopyButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(text);
    setOpen(true);
    setTimeout(() => setOpen(false), 1000);
  };

  return (
    <Tooltip
      title="Text copied to clipboard"
      open={open}
      disableHoverListener
      disableFocusListener
    >
      <IconButton
        onClick={handleCopy}
        size="medium"
        style={{ padding: 2 }}
        aria-label="Copy to clipboard"
      >
        <FileCopyOutlinedIcon style={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
};

export interface InlineFieldProps {
  label: string;
  children: React.ReactNode;
  copyText?: string;
}

export const InlineField = (props: InlineFieldProps) => {
  const { label, children, copyText } = props;
  return (
    <Box display="flex" alignItems="flex-start" py={0.5}>
      <Typography
        variant="body1"
        color="textSecondary"
        style={{ minWidth: 100, flexShrink: 0 }}
      >
        {label}
      </Typography>
      <Box flex={1} minWidth={0} display="flex" alignItems="center">
        {children}
        {copyText && (
          <Box ml={1}>
            <CopyButton text={copyText} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
